import cfdTradingJson from './content/cfd-trading.json';

export const cfdTradingMock = {
    layoutType: 2,
    data: {
        name: 'cfd-trading',
        areasList: [
            {
                id: 1,
                name: 'CfdTradingPage',
                componentName: 'Comp:CfdTradingPage',
                content: JSON.stringify(cfdTradingJson)
            }
        ]
    }
};
